import { SoundsNav } from './sounds-nav';
import './scss/sounds-nav';

new SoundsNav();
